import { StatusModel } from "../../general";

export interface TopicCountModel {
  label: string;
  labelType: 'label' | 'status';
  count: number;
  category: string;
  status?: StatusModel; // If the labelType is status
}